import { render, staticRenderFns } from "./device-management.vue?vue&type=template&id=2cab27fc&"
import script from "./device-management.vue?vue&type=script&lang=js&"
export * from "./device-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports